const formatMonthLabel = (monthStr) => {
    if (!monthStr) return "";
    const [year, month] = monthStr.split("-");
    const date = new Date(year, parseInt(month, 10) - 1); // month is 0-based
    return `${date.toLocaleString("default", { month: "long" })} ${year}`;
};

const formatQuarterLabel = (quarterStr) => {
    if (!quarterStr) return "";
    const [year, quarter] = quarterStr.split("-");
    return `${quarter} ${year}`;
};


export {
    formatMonthLabel,
    formatQuarterLabel
}
